export const decodeToken = (token: string) => {
	try {
		const [, payload] = token.split('.');
		const decodedPayload = JSON.parse(atob(payload));
		return decodedPayload;
	} catch (error) {
		return null;
	}
};
